/* Native scrolling remains available when JavaScript is unavailable. */
if (!customElements.get('minimax-scene-gallery')) {
  customElements.define('minimax-scene-gallery', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.mm-wide__scene-track');
      this.slides = [...this.querySelectorAll('.mm-wide__slide')];
      if (!this.track || this.slides.length < 2) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.previous = this.querySelector('[data-scene-prev]');
      this.next = this.querySelector('[data-scene-next]');
      this.count = this.querySelector('.mm-wide__scene-count');
      this.index = 0;
      this.previous.addEventListener('click', () => this.go(this.index - 1), options);
      this.next.addEventListener('click', () => this.go(this.index + 1), options);
      this.track.addEventListener('keydown', event => {
        const targets = { ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.slides.length - 1 };
        if (!(event.key in targets) || event.altKey || event.ctrlKey || event.metaKey) return;
        event.preventDefault();
        this.go(targets[event.key]);
      }, options);
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.settle);
        this.settle = setTimeout(() => this.sync(), 100);
      }, { ...options, passive: true });
      this.resize = new ResizeObserver(() => this.sync());
      this.resize.observe(this.track);
      this.querySelector('.mm-wide__scene-controls').hidden = false;
      this.sync();
    }

    go(index) {
      const target = Math.max(0, Math.min(this.slides.length - 1, index));
      const left = this.slides[target].offsetLeft - this.slides[0].offsetLeft;
      this.track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }

    sync() {
      const position = this.track.scrollLeft;
      const max = this.track.scrollWidth - this.track.clientWidth;
      const origin = this.slides[0].offsetLeft;
      this.index = position >= max - 2 ? this.slides.length - 1 : this.slides.reduce((best, slide, i) =>
        Math.abs(slide.offsetLeft - origin - position) < Math.abs(this.slides[best].offsetLeft - origin - position) ? i : best, 0);
      this.previous.disabled = this.index === 0;
      this.next.disabled = this.index === this.slides.length - 1;
      this.count.textContent = `${this.index + 1} / ${this.slides.length}`;
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      clearTimeout(this.settle);
    }
  });
}
